import { render, staticRenderFns } from "./SimpleNote5.vue?vue&type=template&id=b7cfa3fc&"
import script from "./SimpleNote5.vue?vue&type=script&lang=js&"
export * from "./SimpleNote5.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNote5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports